import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { environment } from '@env/environment';
import { Account, Integration, User } from 'app/core/models';

declare type SubDomainModalData = { account: Account; integration: Integration; user: User };

@Component({
  selector: 'egnyte-subdomain-modal',
  templateUrl: './egnyte-subdomain-modal.component.html',
  styleUrls: ['./egnyte-subdomain-modal.component.scss'],
})
export class EgnyteSubDomainModalComponent implements OnInit {
  public subDomainForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: SubDomainModalData,
    private readonly matDialogRef: MatDialogRef<EgnyteSubDomainModalComponent>,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.subDomainForm = this.formBuilder.group({
      subdomain: ['', Validators.required],
    });
  }

  public discard(): void {
    this.subDomainForm.reset();
    this.matDialogRef.close();
  }

  public save(): void {
    const subdomain = this.subDomainForm.get('subdomain').value;
    this.subDomainForm.disable();
    this.matDialogRef.close();
    this.navigateToEgnyte(subdomain);
  }

  /**
   * If environment is not production, replace domain param to 'app4termsheet'.
   */
  private navigateToEgnyte(subdomain: string): void {
    const { account, integration, user } = this.data;
    const URL = `${environment.baseUrl}/integrations/${integration.slug}/setup?integration_id=${integration.id}&user_id=${user.id}&domain=${
      environment.production ? subdomain : 'app4termsheet'
    }`;

    return window.location.replace(URL);
  }
}
